import React, { type ReactNode, useState } from "react";
import { Text, Box, type BoxProps } from "@chakra-ui/react";
import { trackEvent, identifyUser, trackConversion } from "lib/analytics";
import { HubSpotForm } from "components/hubspot";

type DemoFormProps = {
  successContent?: ReactNode;
  hideDisabledState?: boolean;
  gdprColor?: string;
  onSubmit?: () => void;
};

export function DemoForm({
  successContent,
  hideDisabledState,
  gdprColor,
  onSubmit,
  ...props
}: DemoFormProps & BoxProps) {
  const [success, setSuccess] = useState<boolean>(false);

  const onFormSubmit = (lead: Record<string, string>) => {
    const cpTenantDomain = "hightouch";
    const cpRouterName = "inbound-router";

    trackEvent("Demo Form Submitted", {
      Email: lead.email,
      "First Name": lead.firstname,
      "Last Name": lead.lastname,
      "Number of Employees": lead.numberofemployees,
      page: window.location.href,
    });

    identifyUser({
      email: lead.email,
      firstName: lead.firstname,
      lastName: lead.lastName,
      companyName: lead.company,
    });

    trackConversion("demo-submitted");

    window.lintrk?.("track", { conversion_id: 4_947_410 });

    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({
      event: "demo_requested",
    });

    // Call the onSubmit handler before the Chili Piper modal launches
    onSubmit?.();

    window.ChiliPiper?.submit?.(cpTenantDomain, cpRouterName, {
      map: true,
      lead,
      onSuccess() {
        setSuccess(true);
      },
      onError() {
        // Show the success modal even if ChiliPiper errors because salesforce lead is still created.
        setSuccess(true);
      },
    });
  };

  return (
    <Box {...props}>
      <HubSpotForm
        label="Book a demo"
        formId="6ba03127-8b95-400c-a229-c5fb099d929f"
        sfdcCampaignId="7015e0000010D1QAAU"
        hideDisabledState={hideDisabledState}
        gdprColor={gdprColor}
        successContent={
          success && (successContent ?? <Text textStyle="caption1">Thank you! We&apos;ll be in touch soon.</Text>)
        }
        onSubmit={onFormSubmit}
      />
    </Box>
  );
}
